

































































import { Component, Vue } from 'vue-property-decorator';
import StateCasesTable from '@/components/StateCasesTable.vue';
import DisplayControls from '@/components/DisplayControls.vue';
import MapSelector from '@/components/MapSelector.vue';
import TwoRowStateSelector from '@/components/TwoRowStateSelector.vue';
import Objective from '@/components/Objective.vue';

import { BIconCaretRightFill, BIconCaretLeftFill } from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css';

import { mapState } from 'vuex';

@Component({
  computed: {
        ...mapState(['selectedMap', 'selectedMapClass', 'fipsStateArray','fipsCountyArray', 'selectedCounty','selectedCountyName','displayOutput','countyCasesArray','countyDeathsArray','countyDataArray','countyCasesAverted','countyDeathsAverted'])
    },
  components: {
      StateCasesTable,
      BIconCaretRightFill, 
      BIconCaretLeftFill,
      TwoRowStateSelector,
      DisplayControls,
      MapSelector,
      Objective
  },
  methods: {
    selectCounty(event) {
      this.$store.dispatch('selectCounty', event.target.value);
      this.$store.dispatch('drawCounty');
    }
  },
  created() {
    // console.log(this.$route.params);
    this.$store.dispatch("setRoute", "county");

  if (this.$route.params.url !== undefined) {
    this.$store.dispatch("searchByCountyURL", this.$route.params.url);
    // this.$forceUpdate();
  }
    // if (this.$route.params.state !== undefined && this.$route.params.countyName !== undefined) {
    //   const abbrev = this.$route.params.state.toUpperCase();
    
    // this.$store.dispatch("searchByAbbrev", abbrev);
    // const county = this.$route.params.countyName;
    // this.$store.dispatch("searchByCountyAbbrev", county);
    // }
    // else if (this.$route.params.state !== undefined && this.$route.params.countyName === undefined) {
    //   const abbrev = this.$route.params.state.toUpperCase();
    //   console.log(abbrev);
    //   this.$store.dispatch("searchByAbbrev", abbrev);
    // }
  },
  mounted() {
    this.$store.dispatch('drawCounty');
    this.$store.dispatch("setHref", this.$router.currentRoute.path);
  }

})
export default class State extends Vue {}
